!(function (e) {
    function t() {
        jQuery(document).height() > jQuery(window).height() &&
            (jQuery(window).width() >= 1200 && jQuery(".main-header").hasClass("sticky_header") && jQuery(this).scrollTop() > 400 ? jQuery(".main-header").addClass("fixed") : jQuery(".main-header").removeClass("fixed"));
    }
    e(document).ready(function () {
        t();
    }),
        e(window).resize(function () {
            t();
        }),
        e(window).scroll(function () {
            t();
        });
    var r = "alwishlistList";
    e(document).ready(function () {
        o.init(), o.closeQuickViewPopup(), e(".quick-view .content").removeAttr("id");
    }),
        e(document).on("click", function (t) {
            var i = e(".quick-view"),
                r = e("#slidedown-cart"),
                a = e(".site-header_cart_link"),
                s = e("#email-modal .modal-window");
            e(".quick-view .overlay, .close-window").on("click", function () {
                i.is(t.target) ||
                    !i.has(t.target) ||
                    r.is(t.target) ||
                    r.is(t.target) ||
                    0 !== r.has(t.target).length ||
                    a.is(t.target) ||
                    0 !== a.has(t.target).length ||
                    s.is(t.target) ||
                    0 !== s.has(t.target).length ||
                    (o.closeQuickViewPopup(), e(".content").removeAttr("id"));
            }),
                i.is(t.target) ||
                    0 !== i.has(t.target).length ||
                    r.is(t.target) ||
                    0 !== r.has(t.target).length ||
                    a.is(t.target) ||
                    0 !== a.has(t.target).length ||
                    s.is(t.target) ||
                    0 !== s.has(t.target).length ||
                    (o.closeDropdownCart(), o.closeEmailModalWindow());
        });
    var o = {
        KidsTimeout: null,
        isSidebarAjaxClick: !1,
        init: function () {
            this.initQuickView(),
                this.initAddToCart(),
                this.initAddToCarts(),
                this.initModal(),
                this.initShortcode(),
                this.productAccordion(),
                this.producteffect(),
                this.productStyle(),
                this.productCompact(),
                this.initProductAddToCart(),
                this.initDropDownCart(),
                this.initWishlist(),
                this.initcompare(),
                this.initProductMoreview(),
                this.initSidebar(),
                this.initColorSwatchGrid(),
                this.initInfiniteScrolling(),
                this.FacetFiltersForm();
        },
        initColorSwatchGrid: function () {
            jQuery(".item-swatch li label,.product-size li label").click(function () {
                var e = jQuery(this).parent().find(".color-pro-change img").attr("src");
                return jQuery(this).closest("ul").find(".active").removeClass("active"), jQuery(this).parent().addClass("active"), jQuery(this).closest(".product-wrapper").find(".featured-image").attr({ src: e }), !1;
            }),
                jQuery(".item-swatch li label,.product-size li label").on("click", function (e) {
                    e.preventDefault(),
                        jQuery(this).closest("ul").find(".active").removeClass("active"),
                        jQuery(this).parent().addClass("active"),
                        jQuery(this).parents(".product-wrapper").find(".product-t").find("img.featured-image").attr("src", jQuery(this).data("image"));
                });
        },
        initWishlist: function () {
            o.updateWishlistButtons(), o.initWishlistButtons();
        },
        initWishlistButtons: function () {
            if (0 == e(".add-in-wishlist-js").length) return !1;
            e(".add-in-wishlist-js").each(function () {
                e(this).unbind(),
                    e(this).click(function (t) {
                        var i = e(".wishlist-count");
                        t.preventDefault();
                        try {
                            var o = e(this).attr("href");
                            if (null == e.cookie(r)) var a = o;
                            else if (-1 == e.cookie(r).indexOf(o)) a = e.cookie(r) + "__" + o;
                            var s = String(a)
                                .split("__")
                                .filter(function (e) {
                                    return null != e && "" != e;
                                });
                            i.text(s.length),
                                e.cookie(r, a, { expires: 14, path: "/" }),
                                jQuery(".default-wishbutton-" + o)
                                    .find("i")
                                    .addClass("mdi-spin mdi-refresh")
                                    .removeClass("mdi-heart-outline"),
                                e(this).closest(".product-information").length > 0
                                    ? setTimeout(function () {
                                          jQuery(".loadding-wishbutton-" + o).remove(), jQuery(".added-wishbutton-" + o).show(), jQuery(".default-wishbutton-" + o).remove();
                                      }, 2e3)
                                    : (jQuery(".loadding-wishbutton-" + o).show(),
                                      jQuery(".default-wishbutton-" + o).remove(),
                                      setTimeout(function () {
                                          jQuery(".loadding-wishbutton-" + o).remove(), jQuery(".added-wishbutton-" + o).show();
                                      }, 2e3)),
                                e(this).unbind();
                        } catch (e) {}
                    });
            });
        },
        updateWishlistButtons: function () {
            try {
                if (null != e.cookie(r) && "__" != e.cookie(r) && "" != e.cookie(r)) {
                    var t = String(e.cookie(r)).split("__"),
                        i = e(".wishlist-count"),
                        o = t.filter(function (e) {
                            return null != e && "" != e;
                        });
                    i.text(o.length);
                    for (var a = 0; a < t.length; a++) "" != t[a] && (jQuery(".added-wishbutton-" + t[a]).show(), jQuery(".default-wishbutton-" + t[a]).remove(), jQuery(".loadding-wishbutton-" + t[a]).remove());
                }
            } catch (e) {}
        },
        initcompare: function () {
            o.initcompareButtons();
        },
        initcompareButtons: function () {
            var t = ".add-in-compare-js",
                i = e(".compare-count"),
                r = e(".max_compare"),
                o = JSON.parse(localStorage.getItem("localCompare")) || [];
            function a() {
                e(t).each(function () {
                    var t = e(this).data("comparehandle"),
                        i = -1 !== e.inArray(t, o) ? "added" : "";
                    e(this).removeClass("added").addClass(i);
                }),
                    i.text(o.length);
            }
            e(document).on("click", t, function (t) {
                var s, n;
                t.preventDefault(),
                    (s = e(this).data("comparehandle")),
                    (n = ""),
                    -1 !== e.inArray(s, o)
                        ? (o.splice(o.indexOf(s), 1), (n = "Item removed to the comparison list!"), jQuery("#modalCompare1").modal(), r.text(n))
                        : 3 === o.length
                        ? ((n = "Maximum products to compare. Limit is 3!"), jQuery("#modalCompare1").modal(), r.text(n))
                        : (o.push(s), (n = "Item added to the comparison list!"), jQuery("#modalCompare1").modal(), r.text(n)),
                    localStorage.setItem("localCompare", JSON.stringify(o)),
                    i.text(o.length),
                    a();
            }),
                e(document).on("click", ".js-remove-compare", function () {
                    var e = $(this).data("comparehandle");
                    o.splice(o.indexOf(e), 1), localStorage.setItem("localCompare", JSON.stringify(o)), a();
                }),
                a();
        },
        productCompact: function () {
            $(".product-design-compact .al-scroll").length > 0 &&
                $(".product-design-compact .al-scroll").nanoScroller({ paneClass: "al-scroll-pane", sliderClass: "al-scroll-slider", contentClass: "al-scroll-content", preventPageScrolling: !1 });
        },
        initShortcode: function () {
            e(".al-toggle").toggle(
                function () {
                    e(this).addClass("active");
                },
                function () {
                    e(this).removeClass("active");
                }
            ),
                e(".al-toggle").click(function () {
                    e(this).next(".al-toggle-content").slideToggle();
                }),
                $(".al-toggle-accordion").on("click", function () {
                    $(this).hasClass("active")
                        ? ($(this).removeClass("active"), $(this).siblings(".al-toggle-faq .al-toggle-content").slideUp(200))
                        : ($(".al-toggle-accordion").removeClass("active"), $(this).addClass("active"), $(".al-toggle-faq .al-toggle-content").slideUp(200), $(this).siblings(".al-toggle-faq .al-toggle-content").slideDown(200));
                });
        },
        productAccordion: function () {
            var e = $(".tabs-layout-accordion"),
                t = window.location.hash,
                i = window.location.href;
            t.toLowerCase().indexOf("comment-") >= 0 || "#reviews" === t || "#tab-reviews" === t || i.indexOf("comment-page-") > 0 || i.indexOf("cpage=") > 0
                ? e.find(".tab-title-reviews").addClass("active")
                : (e.find(".al-accordion-title").first().addClass("active"), e.find(".al-Tabs-panel").first().addClass("active")),
                e.on("click", ".al-accordion-title", function (t) {
                    t.preventDefault();
                    var i = $(this),
                        r = i.siblings(".al-Tabs-panel");
                    i.hasClass("active") ? (i.removeClass("active"), r.stop().slideUp(300)) : (e.find(".al-accordion-title").removeClass("active"), e.find(".al-Tabs-panel").slideUp(), i.addClass("active"), r.stop().slideDown(300)),
                        $(window).resize(),
                        setTimeout(function () {
                            $(window).resize();
                        }, 300);
                });
        },
        producteffect: function () {
            $(".product-wrapper.product_container").on("mouseover", function () {
                var t = e(this).parents(".product-layouts.item-row").data("id");
                t = t.match(/\d+/g);
                var i = e("#product-" + t + ".grid-view-item .product-wrapper");
                i.hasClass("imgloaded") ||
                    (i.addClass("loading"),
                    setTimeout(function () {
                        i.removeClass("loading");
                    }, 1e3)),
                    i.addClass("imgloaded");
            });
        },
        productStyle: function () {
            e(".design_2 .product-wrapper-owlslider .product-block .pro_img").each(function () {
                var t = e(this),
                    i = t.data("image-id");
                e(".design_2 .additinal-product .product-block .pro_img").on("click", function () {
                    e(this).data("image-id") == i && (t.siblings().removeClass("active").removeClass("variant-active"), t.toggleClass("active"), $("html, body").animate({ scrollTop: e(t).offset().top }, 2e3));
                });
            }),
                e(".design_2 select.single-option-selector,.design_3 select.single-option-selector").change(function (e) {
                    var t = [];
                    if (
                        ($(".design_2 select.single-option-selector,.design_3 select.single-option-selector").each(function () {
                            t.push($(this).val());
                        }),
                        t.length > 0)
                    )
                        var i = t.join(" / ");
                    $("select.product-form__variants option").each(function () {
                        if ((e.preventDefault(), 0 == $(this).html().trim().search(i))) {
                            var t = $(this).data("variant-image");
                            $(".design_2 .product-wrapper-owlslider .product-block .pro_img").each(function () {
                                e.preventDefault();
                                var i = $(this);
                                $(this).data("src") == t && (i.siblings().removeClass("variant-active").removeClass("active"), i.toggleClass("variant-active"), $("html, body").animate({ scrollTop: $(i).offset().top }, 2e3));
                            }),
                                $(".design_3 .product-wrapper-owlslider .product-block .owl-item:not(.cloned) .pro_img").each(function () {
                                    if ((e.preventDefault(), $(this).data("src") == t)) {
                                        var i = parseInt($(this).data("position")) - 1;
                                        console.log(i), $(".full_gallery_slider.owl-carousel").trigger("to.owl.carousel", i);
                                    }
                                });
                        }
                    });
                });
        },
        initProductMoreview: function () {
            e("body .al-carousel-lookbook").slick({ slidesToShow: 3, autoplay: !1, speed: 800, slidesToScroll: 1, arrows: !0, dots: !1, infinite: !0 }),
                e(".design_1 .product-wrapper-owlslider .product-single__thumbs.vertical_left").slick({
                    autoplay: !1,
                    autoplaySpeed: 1500,
                    arrows: !0,
                    prevArrow: '<button type="button btn" class="slick-prev"><i class="mdi mdi-chevron-left"></i></button>',
                    nextArrow: '<button type="button btn" class="slick-next"><i class="mdi mdi-chevron-right"></i></button>',
                    centerMode: !0,
                    vertical: !0,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: !1,
                    responsive: [
                        { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1 } },
                        { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 1 } },
                        { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 1, vertical: !1, centerMode: !1 } },
                        { breakpoint: 481, settings: { slidesToShow: 3, slidesToScroll: 1, vertical: !1, centerMode: !1 } },
                    ],
                });
        },
        showModal: function (t) {
            e(t).fadeIn(500),
                (o.KidsTimeout = setTimeout(function () {
                    e(t).fadeOut(500);
                }, 5e3));
        },
        showModalCart: function (t) {
            e(t).fadeIn(500);
        },
        checkItemsInDropdownCart: function () {
            e("#slidedown-cart .mini-products-list").children().length > 0 ? (e("#slidedown-cart .no-items").hide(), e("#slidedown-cart .has-items").show()) : (e("#slidedown-cart .has-items").hide(), e("#slidedown-cart .no-items").show()),
                e("#Sticky-slidedown-cart .mini-products-list").children().length > 0
                    ? (e("#Sticky-slidedown-cart .no-items").hide(), e("#Sticky-slidedown-cart .has-items").show())
                    : (e("#Sticky-slidedown-cart .has-items").hide(), e("#Sticky-slidedown-cart .no-items").show());
        },
        initModal: function () {
            e(".continue-shopping").click(function () {
                clearTimeout(o.KidsTimeout), e(".ajax-success-modal.cart-popup-wrapper").removeClass("open"), e(".ajax-success-modal").fadeOut(500);
            }),
                e(".close-modal,.modal .overlay").click(function () {
                    clearTimeout(o.KidsTimeout), e(".ajax-success-modal.cart-popup-wrapper").removeClass("open"), e(".ajax-success-modal").fadeOut(500), e(".ajax-error-modal").fadeOut(500), jQuery("body").removeClass("cart-open");
                });
        },
        initDropDownCart: function () {
            e(".site-header .site-header_cart_link").on("click", function (t) {
                jQuery(this).toggleClass("active"),
                    t.preventDefault(),
                    e("#slidedown-cart").is(":visible") ? e("#slidedown-cart").slideToggle("fast") : e("#slidedown-cart").slideDown("fast"),
                    jQuery(".page-wrapper").removeClass("ttsearch-fixed"),
                    e(".ttsearch_button").removeClass("active"),
                    jQuery(".site-header__search:not(.search-full) .serach_icon").removeClass("active"),
                    jQuery(window).width() < 992 && jQuery(".header_2 .search_wrapper").slideUp("fast"),
                    jQuery(".header_2 .customer_account").slideUp("fast"),
                    e(".header_2 .myaccount  .dropdown-toggle").removeClass("open"),
                    e(".header_2 .myaccount  .customer_account").slideUp("fast"),
                    jQuery("body").removeClass("search_toggle"),
                    jQuery("body").removeClass("account-toggle");
            }),
                e(".site-header .site-header_cart_link").on("click", function (t) {
                    t.preventDefault(),
                        e(this).toggleClass("active"),
                        e("#Sticky-slidedown-cart").is(":visible") ? e("#Sticky-slidedown-cart").slideToggle("fast") : e("#Sticky-slidedown-cart").slideDown("fast"),
                        e(".header_2 .myaccount  .dropdown-toggle").removeClass("open"),
                        e(".header_2 .myaccount  .customer_account").slideUp("fast"),
                        jQuery("body").removeClass("search_toggle"),
                        jQuery("body").removeClass("account-toggle");
                }),
                e(".site-header_cart_link").on("click", function (t) {
                    t.preventDefault(), e(this).toggleClass("active"), e("#slidedown-cart").toggleClass("active"), e(".fixed-cart-wrap").toggleClass("active"), e("body").toggleClass("cart_toggle");
                }),
                e(".fixed-cart-wrap .cart-close").on("click", function (t) {
                    e("#slidedown-cart,.site-header_cart_link").removeClass("active"), e(".fixed-cart-wrap").removeClass("active"), e("body").removeClass("cart_toggle");
                }),
                o.checkItemsInDropdownCart(),
                e("#slidedown-cart .no-items a").click(function () {
                    e("#slidedown-cart").slideUp("fast");
                }),
                e("#slidedown-cart .btn-remove").click(function (t) {
                    t.preventDefault();
                    var i = e(this).parents(".item").attr("id");
                    (i = i.match(/\d+/g)),
                        Shopify.removeItem(i, function (e) {
                            o.doUpdateDropdownCart(e);
                        });
                }),
                e("#Sticky-slidedown-cart .no-items a").click(function () {
                    e("#Sticky-slidedown-cart").slideUp("fast");
                }),
                e("#Sticky-slidedown-cart .btn-remove").click(function (t) {
                    t.preventDefault();
                    var i = e(this).parents(".item").attr("id");
                    (i = i.match(/\d+/g)),
                        Shopify.removeItem(i, function (e) {
                            o.doUpdateDropdownCart(e);
                        });
                });
        },
        closeDropdownCart: function () {
            e(".site-header:not(.header_2) #Sticky-slidedown-cart").is(":visible") && e(".site-header:not(.header_2) #Sticky-slidedown-cart").slideUp("fast");
        },
        initProductAddToCart: function () {
            jQuery("#AddToCart1").click(function (e) {
                e.preventDefault(), jQuery(".template-product #AddToCart").click();
            }),
                e("#AddToCart").length > 0 &&
                    e("#AddToCart").click(function (t) {
                        if ((t.preventDefault(), jQuery("body").addClass("cart-open"), "disabled" != e(this).attr("disabled"))) {
                            var i = e(this).parents(".product-block"),
                                r = e(i).data("id");
                            if ((console.log(r), (r = r.match(/\d+/g)), console.log(r), window.ajax_cart)) {
                                if (
                                    ((i = e(".product-form-" + r + " select[name=id]").val()) || ((i = e(".product-form-" + r + " input[name=id]").val()), console.log(i)),
                                    (r = e(".product-form-" + r + " input[name=quantity]").val()) || (r = 1),
                                    jQuery("body").hasClass("product_sticky_design_1"))
                                )
                                    var a = e(".design_1 .product__media #productPhotoImg").attr("src");
                                else if (jQuery("body").hasClass("product_sticky_design_2"))
                                    a = e(".design_2 .product-wrapper-owlslider .product-block .product-single__media-wrapper:first-child .pro_img .product-single__thumb #productPhotoImg").attr("src");
                                else if (jQuery("body").hasClass("product_sticky_design_3")) a = e(".design_3 .product-wrapper-owlslider .product-block .owl-item.active.center .pro_img #productPhotoImg").attr("src");
                                console.log(a);
                                var s = e(".product-single__title").text(),
                                    n = e(".product-single__price .price.price--on-sale .sale-price").html(),
                                    c = e(".product-single__price .price:not(.price--on-sale) .regular-price").html();
                                o.doAjaxAddToCart(i, r, a, s, n, c);
                            } else e("form.product-form-" + r).submit();
                        }
                        return !1;
                    });
        },
        initAddToCarts: function () {
            e(".add-cart-btns").length > 0 &&
                e(".add-cart-btns").click(function (t) {
                    if ((t.preventDefault(), jQuery("body").addClass("cart-open"), "disabled" != e(this).attr("disabled"))) {
                        var i = e(this).parents(".item-row"),
                            r = e(i).attr("id");
                        if (((r = r.match(/\d+/g)), window.ajax_cart)) {
                            var a = e(".cart-form-" + r + " select[name=id]").val();
                            a || (a = e(".cart-form-" + r + " input[name=id]").val());
                            var s = e(".cart-form-" + r + " select[name=quantity]").val();
                            s || (s = 1);
                            var n = e(i).find(".featured-image").attr("src"),
                                c = e(i).find(".grid-link__title").text(),
                                d = e(i).find(".grid-view-item__meta").html();
                            o.doAjaxAddToCart(a, s, n, c, d);
                        } else e("form.cart-form-" + r).submit();
                    }
                    return !1;
                });
        },
        initAddToCart: function () {
            e(".add-cart-btn").length > 0 &&
                e(".add-cart-btn").click(function (t) {
                    t.preventDefault(), jQuery("body").addClass("cart-open");
                    var i = e(this).parents(".contents"),
                        r = e(i).data("id"),
                        a = e(this).parents(".product-list .product-layouts"),
                        s = e(a).data("col"),
                        n = e(this).parents(".product-short-list .product-layouts"),
                        c = e(n).data("col"),
                        d = e(this).parents(".product-grid.product-collection-item .product-layouts"),
                        l = e(d).data("col"),
                        u = e(this).parents(".slider-specialproduct .product-layouts"),
                        p = e(u).data("id");
                    if ("disabled" != e(this).attr("disabled")) {
                        var f = e(this).parents(".item-row"),
                            v = e(f).data("col");
                        if (window.ajax_cart) {
                            var m = e(".cart-form-" + v + " select[name=id]").val();
                            if ((m || (m = e(".cart-form-" + v + " input[name=id]").val()), r)) var h = e("#" + r + ".contents.tab-pane .cart-form-" + v + " input[name=quantity]").val();
                            else if (s) h = e(".product-list .product-" + s + " .cart-form-" + v + " input[name=quantity]").val();
                            else if (c) h = e(".product-short-list .product-" + c + " .cart-form-" + v + " input[name=quantity]").val();
                            else if (l) h = e(".product-grid .product-" + l + " .cart-form-" + v + " input[name=quantity]").val();
                            else if (p) h = e(".slider-specialproduct #" + p + " .product-wrapper .cart-form-" + v + " input[name=quantity]").val();
                            else h = e(".product-wrapper .cart-form-" + v + " input[name=quantity]").val();
                            h || (h = 1);
                            var y = e(f).find(".featured-image").attr("src"),
                                g = e(f).find(".grid-link__title").text(),
                                w = e(f).find(".grid-view-item__meta").html();
                            o.doAjaxAddToCart(m, h, y, g, w);
                        } else e("form.cart-form-" + v).submit();
                    }
                    return !1;
                });
        },
        showLoading: function () {
            e(".loading-modal").show();
        },
        hideLoading: function () {
            e(".loading-modal").hide();
        },
        doAjaxAddToCart: function (t, i, r, a, s, n) {
            e.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + i + "&id=" + t,
                dataType: "json",
                beforeSend: function () {
                    o.showLoading();
                },
                success: function (t) {
                    console.log(t),
                        o.hideLoading(),
                        o.showModalCart(".ajax-success-modal"),
                        e(".ajax-success-modal.cart-popup-wrapper").addClass("open"),
                        e(".ajax-success-modal").find(".ajax-product-image").attr("src", r),
                        e(".ajax-success-modal").find(".added-to-wishlist").hide(),
                        e(".ajax-success-modal").find(".added-to-cart").show(),
                        e(".ajax-success-modal").find(".ajax-product-title").text(a),
                        e(".ajax-success-modal").find(".ajax_price").html(s),
                        e(".ajax-success-modal").find(".ajax_price").html(n),
                        e(".ajax-success-modal .total_itmes .popup-qty").text(i),
                        o.updateDropdownCart();
                },
                error: function (t, i) {
                    o.hideLoading(), e(".ajax-error-message").text(e.parseJSON(t.responseText).description), o.showModalCart(".ajax-error-modal");
                },
            });
        },
        initQuickView: function () {
            var t = jQuery(".quick-view .product-shop .product-item").attr("data-id");
            jQuery("#product-actions-" + t)
                .find(".actions .add-to-cart-btn")
                .prepend(jQuery("<i class='mdi mdi-plus'></i>")),
                e(".quick-view-text").click(function () {
                    e(".quick-view").addClass("open-in");
                    var t = e(this).data("id");
                    return (
                        Shopify.getProduct(t, function (t) {
                            console.log(t);
                            var i = jQuery(".quick-view .quick-shop-modal-bg");
                            e(".quick-view").hasClass("open-in") &&
                                (i.show(),
                                setTimeout(function () {
                                    jQuery(".quick-view .quick-shop-modal-bg").hide();
                                }, 2e3));
                            var r = e("#quickview-template").html();
                            e(".quick-view").html(r);
                            var a,
                                s = e(".quick-view");
                            if (
                                (o.loadQuickViewSlider(t, s),
                                (a = (a = t.description).split(" ").splice(0, 40).join(" ") + "..."),
                                s.find(".product-description").html(a),
                                s.find(".price").html(Shopify.formatMoney(t.price, window.money_format)),
                                s.find(".money").html(Shopify.formatMoney(t.price, window.money_format)),
                                s.find(".product-item").attr("id", "product-" + t.id),
                                s.find(".product-item").attr("data-id", t.id),
                                s
                                    .find(".content")
                                    .attr("id", "product-" + t.id)
                                    .css("display", "block"),
                                s.find(".variants").attr("id", "product-actions-" + t.id),
                                s.find(".variants select").attr("id", "product-select-" + t.id),
                                (a = (a = t.description).split(" ").splice(0, 40).join(" ") + "..."),
                                s.find(".product-title a").text(t.title),
                                s.find(".product-title a").attr("href", t.url),
                                s.find(".product-inventory span").length > 0)
                            ) {
                                var n = t.variants[0],
                                    c = s.find(".product-inventory span");
                                n.available
                                    ? (c.text(window.in_stock), c.removeClass("out_of_stock"), c.addClass("in_stock"), jQuery(".quick-view .qty-box-set").css("display", "inline-block"))
                                    : (c.text(window.out_of_stock), c.removeClass("in_stock"), c.addClass("out_of_stock"), jQuery(".quick-view .qty-box-set").css("display", "none"));
                            }
                            if (
                                (t.compare_at_price > t.price
                                    ? (s.find(".compare-price").html(Shopify.formatMoney(t.compare_at_price_max, window.money_format)).show(), s.find(".price").addClass("on-sale"))
                                    : (s.find(".compare-price").html(""), s.find(".price").removeClass("on-sale")),
                                t.available)
                            )
                                s.find(".total-price .price").html(Shopify.formatMoney(t.price, window.money_format)), o.createQuickViewVariants(t, s);
                            else {
                                s.find("select, input, .total-price, .dec, .inc, .variants label").remove(), s.find(".add-to-cart-btn").text("Unavailable").addClass("disabled").attr("disabled", "disabled");
                                var d = jQuery(".quick-view .product-shop .product-item").attr("data-id");
                                jQuery("#product-actions-" + d)
                                    .find(".actions .add-to-cart-btn")
                                    .prepend(jQuery("<i class='mdi mdi-cart-outline'></i>"));
                            }
                            $(".quick-view .qtyplus").on("click", function (e) {
                                e.preventDefault();
                                jQuery(this).parents(".qty-box-set").find(".quantity");
                                var t = parseInt(jQuery(this).parents(".qty-box-set").find(".quantity").val());
                                isNaN(t)
                                    ? jQuery(this).parents(".qty-box-set").find(".quantity").val(1)
                                    : jQuery(this)
                                          .parents(".qty-box-set")
                                          .find(".quantity")
                                          .val(t + 1);
                            }),
                                $(".quick-view .qtyminus").on("click", function (e) {
                                    e.preventDefault();
                                    jQuery(this).parents(".qty-box-set").find(".quantity");
                                    var t = parseInt(jQuery(this).parents(".qty-box-set").find(".quantity").val());
                                    !isNaN(t) && t > 1
                                        ? jQuery(this)
                                              .closest(".qty-box-set")
                                              .find(".quantity")
                                              .val(t - 1)
                                        : jQuery(this).closest(".qty-box-set").find(".quantity").val(1);
                                }),
                                o.initQuickviewAddToCart(),
                                o.hideLoading();
                        }),
                        !1
                    );
                }),
                e(".quick-view .overlay, .close-window").on("click", function () {
                    return o.closeQuickViewPopup(), e(".quick-view").removeClass("open-in"), e(".quick-view").removeClass("option-loader"), e(".quick-view .content").removeAttr("id").css("display", "none"), !1;
                });
        },
        initQuickviewAddToCart: function () {
            e(".quick-view .add-to-cart-btn").length > 0 &&
                e(".quick-view .add-to-cart-btn").click(function (t) {
                    if ((t.preventDefault(), "disabled" != e(this).attr("disabled"))) {
                        var i = e(this).parents(".content"),
                            r = e(i).attr("id");
                        if ((console.log(r), (r = r.match(/\d+/g)), window.ajax_cart)) {
                            var a = e(".quick-view select[name=id]").val();
                            a || (a = e(".quick-view input[name=id]").val()), (i = e(".quick-view input[name=quantity]").val()) || (i = 1);
                            var s = e(".quick-view .product-title a").html(),
                                n = e(".quick-view .more-view-wrapper img").attr("src"),
                                c = e(".quick-view .product-price__price").html();
                            o.doAjaxAddToCart(a, i, n, s, c),
                                o.closeQuickViewPopup(),
                                e(".quick-view .content").removeAttr("id").css("display", "none"),
                                e(".quick-view").removeClass("open-in"),
                                e(".quick-view").removeClass("option-loader");
                        } else e("form#product-actions-" + r).submit();
                    }
                    return !1;
                });
        },
        updateDropdownCart: function () {
            Shopify.getCart(function (e) {
                o.doUpdateDropdownCart(e);
            });
        },
        doUpdateDropdownCart: function (t) {
            console.log(t);
            if (
                (e("#CartCount_sticky .cart-products-count").text(t.item_count),
                e("#minicart_total span.money").html(Shopify.formatMoney(t.total_price, window.money_format)),
                e("#slidedown-cart .summary .price").html(Shopify.formatMoney(t.total_price, window.money_format)),
                e("#slidedown-cart .mini-products-list").html(""),
                e("#Sticky-slidedown-cart .summary .price").html(Shopify.formatMoney(t.total_price, window.money_format)),
                e("#Sticky-slidedown-cart .mini-products-list").html(""),
                e(".ajax-success-modal").find(".ajax_item_total").html(t.item_count),
                t.item_count > 0)
            ) {
                for (var i = 0; i < t.items.length; i++) {
                    var r =
                        '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{PRODUCT_TITLE}" class="product-image"><img src="{IMAGE}" alt="{PRODUCT_TITLE}"></a><div class="product-details"><p class="product-name"><a href="{URL}">{PRODUCT_TITLE}</a></p><div class="variants">{VARIANT_TITLE}</div><div class="cart-collateral"><span class="price">{PRICE}</span> x {QUANTITY}</div></div><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"><span class="mdi mdi-close"></span></a></li>';
                    (r = (r = (r = (r = (r = (r = (r = r.replace(/\{ID\}/g, t.items[i].id)).replace(/\{URL\}/g, t.items[i].url)).replace(/\{PRODUCT_TITLE\}/g, t.items[i].product_title)).replace(
                        /\{VARIANT_TITLE\}/g,
                        t.items[i].variant_title
                    )).replace(/\{QUANTITY\}/g, t.items[i].quantity)).replace(/\{IMAGE\}/g, Shopify.resizeImage(t.items[i].image, "medium"))).replace(/\{PRICE\}/g, Shopify.formatMoney(t.items[i].price, window.money_format))),
                        e("#slidedown-cart .mini-products-list").append(r),
                        e("#Sticky-slidedown-cart .mini-products-list").append(r);
                }
                e("#slidedown-cart .btn-remove").click(function (t) {
                    t.preventDefault();
                    var i = e(this).parents(".item").attr("id");
                    (i = i.match(/\d+/g)),
                        Shopify.removeItem(i, function (e) {
                            o.doUpdateDropdownCart(e);
                        });
                }),
                    e("#Sticky-slidedown-cart .btn-remove").click(function (t) {
                        t.preventDefault();
                        var i = e(this).parents(".item").attr("id");
                        (i = i.match(/\d+/g)),
                            Shopify.removeItem(i, function (e) {
                                o.doUpdateDropdownCart(e);
                            });
                    }),
                    o.checkNeedToConvertCurrency() &&
                        (Currency.convertAll(window.shop_currency, jQuery(".currencies li.active .currencies-a").val(), "#slidedown-cart span.money", "money_format"),
                        Currency.convertAll(window.shop_currency, jQuery(".currencies li.active .currencies-a").val(), "#Sticky-slidedown-cart span.money", "money_format"),
                        Currency.convertAll(window.shop_currency, jQuery(".currencies li.active .currencies-a").val(), "span.money", "money_format"),
                        Currency.convertAll(window.shop_currency, jQuery(".currencies li.active .currencies-a").val(), "#minicart_total span.money", "money_format"));
            }
            o.checkItemsInDropdownCart();
        },
        checkNeedToConvertCurrency: function () {
            return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
        },
        loadQuickViewSlider: function (t, r) {
            var a = Shopify.resizeImage(t.featured_image, "large");
            if ((r.find(".quickview-featured-image").append('<img class="quick-image" height="auto" width="364" src="' + a + '" title="' + t.title + '"/>'), t.images.length > 1)) {
                var s = r.find(".more-view-wrapper ul"),
                    n = $(t.images).length;
                for (i = 0; i < n; i++) {
                    var c = '<li><a href="javascript:void(0)" data-image="' + Shopify.resizeImage(t.images[i], "large") + '"><img height="auto" width="85" src="' + Shopify.resizeImage(t.images[i], "medium") + '"  /></a></li>';
                    s.append(c), $("li").first().find("a").addClass("active");
                }
                $("body.rtl").length > 0 ? (s.hasClass("quickview-more-views-owlslider"), o.initQuickViewMoreviewRtl(s)) : (s.hasClass("quickview-more-views-owlslider"), o.initQuickViewMoreview(s)),
                    s.find("a").click(function () {
                        var t = r.find(".quickview-featured-image img"),
                            i = r.find(".quickview-featured-image div");
                        t.attr("src") != e(this).attr("data-image") &&
                            (t.attr("src", e(this).attr("data-image")),
                            i.show(),
                            e("a").removeClass("active"),
                            e(this).addClass("active"),
                            t.load(function (t) {
                                i.hide(), e(this).unbind("load"), i.hide();
                            }));
                    });
            } else r.find(".more-view-wrapper").remove(), $("a").removeClass("active");
            e(".quick-view .overlay, .close-window").on("click", function () {
                return o.closeQuickViewPopup(), e(".quick-view").removeClass("open-in"), e(".quick-view").removeClass("option-loader"), e(".quick-view .content").removeAttr("id").css("display", "none"), !1;
            });
        },
        closeEmailModalWindow: function () {
            e("#email-modal").length > 0 &&
                e("#email-modal").is(":visible") &&
                e("#email-modal .modal-window").fadeOut(600, function () {
                    e("#email-modal .modal-overlay").fadeOut(600, function () {
                        e("#email-modal").hide(), e.cookie("emailSubcribeModal", "closed", { expires: 1, path: "/" });
                    });
                });
        },
        initQuickViewMoreview: function (e) {
            e &&
                (e.owlCarousel({ nav: !0, items: 3, loop: !1, rtl: !1, responsive: { 0: { items: 2 }, 600: { items: 2 }, 768: { items: 3 }, 992: { items: 2 }, 1200: { items: 3 } }, dots: !1 }),
                setTimeout(function () {
                    $(e).css("visibility", "visible");
                }, 500));
        },
        initQuickViewMoreviewRtl: function (e) {
            e &&
                (e.owlCarousel({ nav: !0, items: 3, loop: !1, rtl: !0, responsive: { 0: { items: 2 }, 600: { items: 2 }, 768: { items: 3 }, 992: { items: 2 }, 1200: { items: 3 } }, dots: !1 }),
                setTimeout(function () {
                    $(e).css("visibility", "visible");
                }, 500));
        },
        convertToSlug: function (e) {
            return e
                .toLowerCase()
                .replace(/[^a-z0-9 -]/g, "")
                .replace(/\s+/g, "-")
                .replace(/-+/g, "-");
        },
        selectCallbackQuickview: function (e, t) {
            var i = jQuery(".quick-view .product-item"),
                r = i.find(".add-to-cart-btn"),
                o = i.find(".price"),
                a = i.find(".compare-price"),
                s = (i.find(".total-price span"), i.find(".product-inventory"));
            i.find(".product-inventory span");
            if (e && e.featured_image) {
                var n = jQuery(".quick-image"),
                    c = e.featured_image,
                    d = n[0];
                Shopify.Image.switchImage(c, d, function (e, t, i) {
                    $(i).attr("src", e);
                });
            }
            if (e) {
                if (e.available) r.text("Add to Cart").removeClass("disabled").removeAttr("disabled"), s.css("display", "block");
                else {
                    r.text("Sold Out").val("Sold Out").addClass("disabled").attr("disabled", "disabled"), s.css("display", "none");
                    var l = jQuery(".quick-view .product-shop .product-item").attr("data-id");
                    jQuery("#product-actions-" + l)
                        .find(".actions .add-to-cart-btn")
                        .prepend(jQuery("<i class='mdi mdi-cart-outline'></i>"));
                }
                o.html(Shopify.formatMoney(e.price, theme.moneyFormat)),
                    e.compare_at_price > e.price
                        ? (a.html(Shopify.formatMoney(e.compare_at_price, theme.moneyFormat)).show(),
                          Currency.convertAll(window.shop_currency, jQuery(".currencies li.active .currencies-a").val(), "span.money", "money_format"),
                          o.addClass("on-sale"))
                        : (a.hide(), o.removeClass("on-sale"));
                var u = i.find(".product-inventory span");
                if (e.available) {
                    u.text(window.in_stock), u.removeClass("out_of_stock"), u.addClass("in_stock"), jQuery(".qty-box-set").css("display", "inline-block");
                    l = jQuery(".quick-view .product-shop .product-item").attr("data-id");
                    jQuery("#product-actions-" + l)
                        .find(".actions .add-to-cart-btn")
                        .prepend(jQuery("<i class='mdi mdi-cart-outline'></i>"));
                } else u.text(window.out_of_stock), u.removeClass("in_stock"), u.addClass("out_of_stock"), jQuery(".qty-box-set").css("display", "none");
                if (e && e.featured_image)
                    (c = (c = Shopify.resizeImage(e.featured_image.src, "small")).replace(/https?: /, "")),
                        jQuery(".quick-view .quickview-more-views img").each(function () {
                            if (jQuery(this).attr("src") == c) return jQuery(this).parent().trigger("click"), !1;
                        });
            } else {
                r.text("Unavailable").addClass("disabled").attr("disabled", "disabled"), s.css("display", "none");
                l = jQuery(".quick-view .product-shop .product-item").attr("data-id");
                jQuery("#product-actions-" + l)
                    .find(".actions .add-to-cart-btn")
                    .prepend(jQuery("<i class='mdi mdi-cart-outline'></i>"));
            }
            Currency.convertAll(window.shop_currency, jQuery(".currencies li.active .currencies-a").val(), "span.money", "money_format");
        },
        createQuickViewVariants: function (e, t) {
            if (e.variants.length >= 1) {
                for (var i = 0; i < e.variants.length; i++) {
                    var r = '<option value="' + (d = e.variants[i]).id + '">' + d.title + "</option>";
                    t.find("form.variants > select").append(r);
                }
                new Shopify.OptionSelectors("product-select-" + e.id, { product: e, onVariantSelected: this.selectCallbackQuickview, enableHistoryState: !0 });
                var a = "";
                for (i = 0; i < e.options.length; i++) {
                    a += '<div class="swatch clearfix" data-option-index="' + i + '">';
                    var s = !1;
                    /Color|Colour/i.test(e.options[i].name) && (s = !0);
                    for (var n = new Array(), c = 0; c < e.variants.length; c++) {
                        var d,
                            l = (d = e.variants[c]).options[i],
                            u = o.convertToSlug(l),
                            p = "swatch-" + i + "_" + u;
                        n.indexOf(l) < 0 &&
                            ((a += '<div data-value="' + l + '" class=" ' + (s ? "color" : "") + u + (d.available ? " available " : " soldout ") + '">'),
                            (a += '<input id="' + p + '" type="radio" name="option-' + i + '" value="' + l + '" ' + (0 == c ? " checked " : "") + (d.available ? "" : " disabled") + " />"),
                            (a += s ? '<label class="link_color" for="' + p + '" style="background-color: ' + u + ';"></label>' : '<label class="variant_other" for="' + p + '">' + l + "</label>"),
                            (a += "</div>"),
                            d.available &&
                                $('.quickview-product .swatch[data-option-index="' + i + '"] .' + u)
                                    .removeClass("soldout")
                                    .addClass("available")
                                    .find(":radio")
                                    .removeAttr("disabled"),
                            n.push(l));
                    }
                    a += "</div>";
                }
                t.find("form.variants > select").after(a),
                    t.find(".swatch :radio").change(function () {
                        var e = $(this).closest(".swatch").attr("data-option-index"),
                            t = $(this).val();
                        $(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change");
                    }),
                    e.available && e.options.size > 1 && ((Shopify.optionsMap = {}), Shopify.linkOptionSelectors(e));
            } else {
                t.find("form.variants > select").remove();
                var f = '<input type="hidden" name="id" value="' + e.variants[0].id + '">';
                t.find("form.variants").append(f);
            }
        },
        closeQuickViewPopup: function () {},
        initSidebar: function () {
            e(".collection_sidebar").length > 0 && (o.sidebarParams(), o.sidebarMapEvents(), o.sidebarMapClear(), o.sidebarMapClearAll(), o.initSortby(), o.sidebarMapPaging());
        },
        sidebarMapView: function () {
            e(".view-mode a.active").removeClass("active"),
                e(this).addClass("active"),
                jQuery(".products-grid-view  > .product-list .product-thumb").attr("class", "product-thumb col-xs-5 col-sm-5 col-md-4 col-4"),
                jQuery(".products-grid-view > .product-list .product-description").attr("class", "product-description col-xs-7 col-sm-7 col-md-8 col-8"),
                jQuery(".products-grid-view > div.product-collection-item").each(function () {
                    var e = jQuery(this).find(".product-collection-item.product-grid .product-wrapper .product-thumb div.col-sm-12");
                    jQuery(this).find(".product-collection-item.product-grid .product-wrapper .product-description .flip-countdown.simple-countdown").appendTo(e);
                }),
                jQuery(".products-grid-view > .product-grid .product-thumb").attr("class", "thumbs product-thumb col-xs-12 padding_0"),
                jQuery(".products-grid-view > .product-grid .product-description").attr("class", "product-description col-xs-12"),
                jQuery(".products-grid-view > div.product-collection-item").addClass("product-grids"),
                jQuery("#list-view").on("click", function () {
                    jQuery(".products-grid-view > div.product-collection-item").removeClass("product-grids"),
                        jQuery(".products-grid-view > div.product-collection-item").removeClass("product-short-list"),
                        jQuery(".products-grid-view > div.product-collection-item").removeClass("product-grid"),
                        jQuery(".products-grid-view > div.product-collection-item").addClass("product-list"),
                        jQuery("#grid-views").removeClass("active"),
                        jQuery("#grid-view").removeClass("active"),
                        jQuery("#short-list-view").removeClass("active"),
                        jQuery("#list-view").addClass("active"),
                        jQuery(".products-grid-view > .product-list .product-thumb").attr("class", "product-thumb col-xs-5 col-sm-5 col-md-4 col-4"),
                        jQuery(".products-grid-view > .product-list .product-description").attr("class", "product-description col-xs-7 col-sm-7 col-md-8 col-8"),
                        jQuery(".products-grid-view > div.product-list").each(function () {
                            var e = jQuery(this).find(".product-wrapper .product-description .product-description-wrap .short-title");
                            jQuery(e).children().unwrap();
                        }),
                        jQuery(".products-grid-view > div.product-collection-item").each(function () {
                            jQuery(this).find(".grid-view-item__title");
                            var e = jQuery(this).find(".product-description .product-desc");
                            jQuery(this).find(".product-wrapper .flip-countdown.simple-countdown").insertAfter(e);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style1").each(function () {
                            var e = jQuery(this).find(".product-description");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            var t = jQuery(this).find(".grid-view-item__meta");
                            jQuery(this).find(".product-qty").insertAfter(t);
                            var i = jQuery(this).find(".grid-view-item__meta");
                            jQuery(this).find(".options-color-size").insertAfter(i);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style2").each(function () {
                            var e = jQuery(this).find(".product-description");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            var t = jQuery(this).find(".product-wrapper .product-description .btn_wrapper");
                            jQuery(this).find(".add-to-compare").prependTo(t);
                            var i = jQuery(this).find(".grid-view-item__meta");
                            jQuery(this).find(".options-color-size").insertAfter(i);
                            var r = jQuery(this).find(".grid-view-item__meta");
                            jQuery(this).find(".product-qty").insertAfter(r);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style3").each(function () {
                            var e = jQuery(this).find(".product-description");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            var t = jQuery(this).find(".product-description .btn_wrapper");
                            jQuery(this).find(".pro_btn.add_tocart").prependTo(t);
                            var i = jQuery(this).find(".grid-view-item__meta");
                            jQuery(this).find(".options-color-size").insertAfter(i);
                            var r = jQuery(this).find(".grid-view-item__meta");
                            jQuery(this).find(".product-qty").insertAfter(r);
                        }),
                        jQuery(".products-grid-view > div.product-list").each(function () {
                            var e = jQuery(this).find(".product-wrapper .product-description .short-title");
                            jQuery(e).children().unwrap();
                        }),
                        localStorage.setItem("display", "list");
                    var t = e(".filter-show  button span").text();
                    Shopify.queryParams.view = t;
                }),
                jQuery("#short-list-view").on("click", function () {
                    jQuery(".products-grid-view > div.product-collection-item").removeClass("product-grids"),
                        jQuery(".products-grid-view > div.product-collection-item ").removeClass("product-grids"),
                        jQuery(".products-grid-view > div.product-collection-item ").removeClass("product-grid"),
                        jQuery(".products-grid-view > div.product-collection-item ").removeClass("product-list"),
                        jQuery(".products-grid-view > div.product-collection-item ").addClass("product-short-list"),
                        jQuery("#grid-views").removeClass("active"),
                        jQuery("#grid-view").removeClass("active"),
                        jQuery("#list-view").removeClass("active"),
                        jQuery("#short-list-view").addClass("active"),
                        jQuery(".products-grid-view > .product-short-list .product-thumb").attr("class", "product-thumb col-xs-4 col-sm-3 col-md-3 col-4"),
                        jQuery(".products-grid-view > .product-short-list .product-description").attr("class", "product-description col-xs-8 col-sm-9 col-md-9 col-8"),
                        jQuery(".product-wrapper .product-description .grid-view-item__vendor").addClass("grid-item-meta"),
                        jQuery(".product-wrapper .product-description .grid-view-item__title").addClass("grid-item-meta"),
                        jQuery(".products-grid-view > div.product-short-list").each(function () {
                            var e = jQuery(this).find(".product-wrapper .product-description > .grid-item-meta");
                            jQuery(e).wrapAll('<div class="short-title col-xs-6 col-sm-5"></div>');
                            e = jQuery(this).find(".product-wrapper .product-description .product-content > .grid-item-meta");
                            jQuery(e).wrapAll('<div class="short-title col-xs-6 col-sm-5"></div>');
                        }),
                        jQuery(".products-grid-view > div.product-collection-item").each(function () {
                            var e = jQuery(this).find(".product-description .short-title");
                            jQuery(this).find(".options-color-size").appendTo(e);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style1 ").each(function () {
                            var e = jQuery(this).find(".product-wrapper .product-description");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            var t = jQuery(this).find(".product-wrapper .product-description .grid-view-item__meta");
                            jQuery(this).find(".product-qty").appendTo(t);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style2 ").each(function () {
                            var e = jQuery(this).find(".product-wrapper .product-description");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            e = jQuery(this).find(".product-wrapper .product-description .btn_wrapper .add_tocart");
                            jQuery(this).find(".add-to-compare").insertAfter(e);
                            var t = jQuery(this).find(".product-wrapper .product-description .grid-view-item__meta");
                            jQuery(this).find(".product-qty").appendTo(t);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style3").each(function () {
                            var e = jQuery(this).find(".product-description .short-title");
                            jQuery(this).find(".options-color-size").appendTo(e);
                            var t = jQuery(this).find(".product-wrapper .product-description");
                            jQuery(this).find(".btn_wrapper").appendTo(t);
                            t = jQuery(this).find(".product-wrapper .product-description .btn_wrapper .add-to-wishlist");
                            jQuery(this).find(".add_tocart").insertBefore(t);
                            var i = jQuery(this).find(".product-wrapper .product-description .grid-view-item__meta");
                            jQuery(this).find(".product-qty").appendTo(i);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item").each(function () {
                            var e = jQuery(this).find(".product-description .short-title");
                            jQuery(this).find(".product-wrapper .flip-countdown.simple-countdown").appendTo(e);
                        }),
                        localStorage.setItem("display", "short-list");
                    var t = e(".filter-show  button span").text();
                    Shopify.queryParams.view = t;
                }),
                jQuery("#grid-views").on("click", function () {
                    jQuery("#grid-view").removeClass("active"),
                        jQuery("#list-view").removeClass("active"),
                        jQuery("#short-list-view").removeClass("active"),
                        jQuery("#grid-views").addClass("active"),
                        jQuery(".products-grid-view > div.product-collection-item ").removeClass("product-grid"),
                        jQuery(".products-grid-view > div.product-collection-item ").removeClass("product-list"),
                        jQuery(".products-grid-view > div.product-collection-item ").removeClass("product-short-list"),
                        jQuery(".products-grid-view > div.product-collection-item ").addClass("product-grids"),
                        jQuery(".products-grid-view > .product-grids .product-thumb").attr("class", "product-thumb col-12 padding_0"),
                        jQuery(".products-grid-view > .product-grids .product-description").attr("class", "product-description col-12"),
                        localStorage.setItem("display", "grid"),
                        jQuery(".products-grid-view > div.product-collection-item").each(function () {
                            var e = jQuery(this).find(".product-thumb .fade_img");
                            jQuery(this).find(".product-description .flip-countdown.simple-countdown").appendTo(e);
                        }),
                        jQuery(".products-grid-view > div.product-grids").each(function () {
                            var e = jQuery(this).find(".product-wrapper .product-description .short-title");
                            jQuery(e).children().unwrap();
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style1").each(function () {
                            var e = jQuery(this).find(".product-thumb");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            var t = jQuery(this).find(".btn_wrapper");
                            jQuery(this).find(".product-qty").insertBefore(t);
                            var i = jQuery(this).find(".grid-view-item__meta");
                            jQuery(this).find(".options-color-size").insertAfter(i);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style2").each(function () {
                            var e = jQuery(this).find(".product-thumb");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            var t = jQuery(this).find(".btn_wrapper");
                            jQuery(this).find(".product-qty").insertBefore(t);
                            var i = jQuery(this).find(".btn_wrapper");
                            jQuery(this).find(".add-to-compare").prependTo(i);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style3").each(function () {
                            var e = jQuery(this).find(".product-thumb");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            var t = jQuery(this).find(".btn_wrapper");
                            jQuery(this).find(".options-color-size").insertBefore(t);
                            var i = jQuery(this).find(".product-description .grid-view-item__meta");
                            jQuery(this).find(".pro_btn.add_tocart").insertAfter(i);
                            var r = jQuery(this).find(".pro_btn.add_tocart");
                            jQuery(this).find(".product-qty").insertAfter(r);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.product-grids.style3").each(function () {
                            var e = jQuery(this).find(".product-thumb");
                            jQuery(this).find(".pro_btn.add_tocart").appendTo(e);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item").each(function () {
                            var e = jQuery(this).find(".product-thumb div.col-xs-12");
                            jQuery(this).find(".product-wrapper .flip-countdown.simple-countdown").appendTo(e);
                        }),
                        localStorage.setItem("display", "product-grids");
                    var t = e(".filter-show  button span").text();
                    Shopify.queryParams.view = t;
                }),
                jQuery("#grid-view").on("click", function () {
                    jQuery("#grid-views").removeClass("active"),
                        jQuery("#list-view").removeClass("active"),
                        jQuery("#short-list-view").removeClass("active"),
                        jQuery("#grid-view").addClass("active"),
                        jQuery(".products-grid-view > div.product-collection-item ").removeClass("product-grids"),
                        jQuery(".products-grid-view > div.product-collection-item ").removeClass("product-list"),
                        jQuery(".products-grid-view > div.product-collection-item ").removeClass("product-short-list"),
                        jQuery(".products-grid-view > div.product-collection-item ").addClass("product-grid"),
                        jQuery(".products-grid-view > .product-grid .product-thumb").attr("class", "product-thumb col-xs-12 padding_0"),
                        jQuery(".products-grid-view > .product-grid .product-description").attr("class", "product-description col-xs-12"),
                        localStorage.setItem("display", "grid"),
                        jQuery(".products-grid-view > div.product-collection-item").each(function () {
                            var e = jQuery(this).find(".product-thumb .fade_img");
                            jQuery(this).find(".product-description .flip-countdown.simple-countdown").appendTo(e);
                        }),
                        jQuery(".products-grid-view > div.product-grid").each(function () {
                            var e = jQuery(this).find(".product-wrapper .product-description .short-title");
                            jQuery(e).children().unwrap();
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style1").each(function () {
                            var e = jQuery(this).find(".product-thumb");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            var t = jQuery(this).find(".btn_wrapper");
                            jQuery(this).find(".product-qty").insertBefore(t);
                            var i = jQuery(this).find(".grid-view-item__meta");
                            jQuery(this).find(".options-color-size").insertAfter(i);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style2").each(function () {
                            var e = jQuery(this).find(".product-thumb");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            var t = jQuery(this).find(".btn_wrapper");
                            jQuery(this).find(".product-qty").insertBefore(t);
                            var i = jQuery(this).find(".btn_wrapper");
                            jQuery(this).find(".add-to-compare").prependTo(i);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.style3").each(function () {
                            var e = jQuery(this).find(".product-thumb");
                            jQuery(this).find(".btn_wrapper").appendTo(e);
                            var t = jQuery(this).find(".btn_wrapper");
                            jQuery(this).find(".options-color-size").insertBefore(t);
                            var i = jQuery(this).find(".product-description .grid-view-item__meta");
                            jQuery(this).find(".pro_btn.add_tocart").insertAfter(i);
                            var r = jQuery(this).find(".pro_btn.add_tocart");
                            jQuery(this).find(".product-qty").insertAfter(r);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item.product-grid.style3").each(function () {
                            var e = jQuery(this).find(".product-thumb");
                            jQuery(this).find(".pro_btn.add_tocart").appendTo(e);
                        }),
                        jQuery(".products-grid-view > div.product-collection-item").each(function () {
                            var e = jQuery(this).find(".product-thumb div.col-xs-12");
                            jQuery(this).find(".product-wrapper .flip-countdown.simple-countdown").appendTo(e);
                        });
                    var t = e(".filter-show  button span").text();
                    Shopify.queryParams.view = t;
                }),
                jQuery(window).width() < 992 &&
                    (jQuery(".sidebar .widget > h4").addClass("toggle"),
                    jQuery(".sidebar .widget ").children(":nth-child(2)").css("display", "none"),
                    jQuery(".sidebar .widget.active").children(":nth-child(2)").css("display", "block"),
                    jQuery(".sidebar .widget > h4.toggle").unbind("click"),
                    jQuery(".sidebar .widget > h4.toggle").on("click", function () {
                        jQuery(this).parent().toggleClass("active").children(":nth-child(2)").slideToggle("fast");
                    })),
                "grid" == localStorage.getItem("display")
                    ? jQuery("#grid-view").trigger("click")
                    : "grids" == localStorage.getItem("display")
                    ? jQuery("#grid-views").trigger("click")
                    : "list" == localStorage.getItem("display")
                    ? jQuery("#list-view").trigger("click")
                    : "short-list" == localStorage.getItem("display")
                    ? jQuery("#short-list-view").trigger("click")
                    : jQuery("#grid-view").trigger("click"),
                countDownIni(".flip-countdown");
        },
        sidebarMapSorting: function (t) {
            e(".filter-sortby a").click(function (t) {
                if (!e(this).parent().hasClass("active")) {
                    (Shopify.queryParams.sort_by = e(this).attr("href")), o.sidebarAjaxClick();
                    var i = e(this).text();
                    e(".filter-sortby  button span").text(i), e(".filter-sortby li.active").removeClass("active"), e(this).parent().addClass("active");
                }
                t.preventDefault();
            });
        },
        sidebarMapShow: function () {
            e(".filter-show a").click(function (t) {
                if (!e(this).parent().hasClass("active")) {
                    var i = e(this).attr("href");
                    (Shopify.queryParams.view = i), o.sidebarAjaxClick(), e(".filter-show .btn span").text(i), e(".filter-show li.active").removeClass("active"), e(this).parent().addClass("active");
                }
                t.preventDefault();
            });
        },
        initSortby: function () {
            if (Shopify.queryParams.sort_by) {
                var t = Shopify.queryParams.sort_by,
                    i = e(".filter-sortby a[href='" + t + "']").text();
                e(".filter-sortby  button span").text(i),
                    e(".filter-sortby li.active").removeClass("active"),
                    e(".filter-sortby a[href='" + t + "']")
                        .parent()
                        .addClass("active");
            }
        },
        sidebarMapPaging: function () {
            e(".pagination-custom a").click(function (t) {
                var i = e(this)
                    .attr("href")
                    .match(/page=\d+/g);
                if (i && ((Shopify.queryParams.page = parseInt(i[0].match(/\d+/g))), Shopify.queryParams.page)) {
                    var r = o.sidebarCreateUrl();
                    (o.isSidebarAjaxClick = !0), History.pushState({ param: Shopify.queryParams }, r, r), o.sidebarGetContent(r), e("body,html").animate({ scrollTop: 500 }, 600);
                }
                $.ajax({
                    type: "get",
                    url: r,
                    beforeSend: function () {
                        o.showLoading();
                    },
                    success: function (e) {
                        var t = $(e).find(".col-main .products-grid-view");
                        if (t.length) {
                            var i = t.children().length,
                                r = ($(".loadcount").html(), parseInt(i));
                            $(".loadcount").html(r), $(".pag-product").html(r);
                        }
                    },
                }),
                    t.preventDefault();
            });
        },
        sidebarMapTagEvents: function () {
            jQuery(window).width() < 992 &&
                (jQuery(".collection_right .sidebar .widget > h4,.collection_left .sidebar .widget > h4,.blog-section .sidebar .widget > h4").addClass("toggle"),
                jQuery(".collection_right .sidebar .widget,.collection_left .sidebar .widget,.blog-section .sidebar .widget").children(":nth-child(2)").css("display", "none"),
                jQuery(".collection_right .sidebar .widget.active,.collection_left .sidebar .widget.active,.blog-section .sidebar .widget.active").children(":nth-child(2)").css("display", "block"),
                jQuery(".collection_right .sidebar .widget > h4.toggle,.collection_left .sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").unbind("click"),
                jQuery(".collection_right .sidebar .widget > h4.toggle,.collection_left .sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").on("click", function () {
                    jQuery(this).parent().toggleClass("active").children(":nth-child(2)").slideToggle("fast");
                })),
                jQuery(window).width() < 992 &&
                    (jQuery(".collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4").addClass("toggle"),
                    jQuery(".collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget ").children(":nth-child(2)").css("display", "none"),
                    jQuery(".collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active").children(":nth-child(2)").css("display", "block"),
                    jQuery(".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle").unbind("click"),
                    jQuery(".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle").on("click", function () {
                        jQuery(this).parent().toggleClass("active").children(":nth-child(2)").slideToggle("fast");
                    })),
                e('.sidebar-tag a:not(".clear"), .sidebar-tag label').click(function (t) {
                    e(this).addClass("active");
                    var i = [];
                    if ((Shopify.queryParams.constraint && (i = Shopify.queryParams.constraint.split("+")), !window.enable_sidebar_multiple_choice && !e(this).prev().is(":checked"))) {
                        var r,
                            a,
                            s = e(this).parents(".sidebar-tag").find("input:checked");
                        if (s.length > 0) if ((r = s.val())) (a = i.indexOf(r)) >= 0 && i.splice(a, 1);
                    }
                    (r = e(this).prev().val()) && ((a = i.indexOf(r)) >= 0 ? i.splice(a, 1) : i.push(r));
                    i.length ? (Shopify.queryParams.constraint = i.join("+")) : delete Shopify.queryParams.constraint, o.sidebarAjaxClick(), t.preventDefault();
                });
        },
        sidebarInitToggle: function () {
            e(".sidebar-tag").length > 0 &&
                e(".sidebar-tag .widget span").click(function () {
                    var t = e(this).parents(".widget");
                    t.hasClass("click") ? t.removeClass("click") : t.addClass("click"), e(this).parents(".sidebar-tag").find(".widget-content").slideToggle();
                });
        },
        sidebarMapClearAll: function () {
            e(".refined-widgets a.clear-all").click(function (e) {
                delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, o.sidebarAjaxClick(), e.preventDefault();
            });
        },
        sidebarMapClear: function () {
            e(".sidebar-tag").each(function () {
                var t = e(this);
                t.find("input:checked").length > 0 &&
                    t
                        .find(".clear")
                        .show()
                        .click(function (i) {
                            var r = [];
                            Shopify.queryParams.constraint && (r = Shopify.queryParams.constraint.split("+")),
                                t.find("input:checked").each(function () {
                                    var t = e(this).val();
                                    if (t) {
                                        var i = r.indexOf(t);
                                        i >= 0 && r.splice(i, 1);
                                    }
                                }),
                                r.length ? (Shopify.queryParams.constraint = r.join("+")) : delete Shopify.queryParams.constraint,
                                o.sidebarAjaxClick(),
                                i.preventDefault();
                        });
            });
        },
        sidebarMapEvents: function () {
            o.sidebarMapTagEvents(), o.sidebarMapView(), o.sidebarMapSorting(), o.sidebarMapShow();
        },
        reActivateSidebar: function () {
            if ((e(".sidebar-tag .active").removeClass("active"), e(".sidebar-tag input:checked").attr("checked", !1), Shopify.queryParams.view)) {
                e(".view-mode .active").removeClass("active");
                var t = Shopify.queryParams.view;
                t.indexOf("list") >= 0 ? (e(".view-mode .list").addClass("active"), (t = t.replace("list", ""))) : e(".view-mode .grid").addClass("active"),
                    e(".filter-show  button span").text(t),
                    e(".filter-show li.active").removeClass("active"),
                    e(".filter-show a[href='" + t + "']")
                        .parent()
                        .addClass("active");
            }
            o.initSortby();
        },
        sidebarMapData: function (t) {
            var i = e(".col-main .products-grid-view"),
                r = e(t).find(".col-main .products-grid-view");
            if (
                (i.replaceWith(r),
                o.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, jQuery(".currencies li.active .currencies-a").val(), "span.money", "money_format"),
                e(".refined-widgets").replaceWith(e(t).find(".refined-widgets")),
                e(".sidebar-block").replaceWith(e(t).find(".sidebar-block")),
                $(".product-layouts .qtyplus").on("click", function (e) {
                    e.preventDefault();
                    jQuery(this).parents(".qty-box-set").find(".quantity");
                    var t = parseInt(jQuery(this).parents(".qty-box-set").find(".quantity").val());
                    isNaN(t)
                        ? jQuery(this).parents(".qty-box-set").find(".quantity").val(1)
                        : jQuery(this)
                              .parents(".qty-box-set")
                              .find(".quantity")
                              .val(t + 1);
                }),
                $(".product-layouts .qtyminus").on("click", function (e) {
                    e.preventDefault();
                    jQuery(this).parents(".qty-box-set").find(".quantity");
                    var t = parseInt(jQuery(this).parents(".qty-box-set").find(".quantity").val());
                    !isNaN(t) && t > 1
                        ? jQuery(this)
                              .closest(".qty-box-set")
                              .find(".quantity")
                              .val(t - 1)
                        : jQuery(this).closest(".qty-box-set").find(".quantity").val(1);
                }),
                countDownIni(".flip-countdown"),
                $(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a").click(function () {
                    $(this).addClass("loading"),
                        setTimeout(function () {
                            $(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a").removeClass("loading");
                        }, 2e3);
                }),
                e(".pagination-wrap").length > 0 ? e(".pagination-wrap").replaceWith(e(t).find(".pagination-wrap")) : e(e(t).find(".pagination-wrap")).insertAfter(".col-main"),
                "grid" == localStorage.getItem("display")
                    ? jQuery("#grid-view").trigger("click")
                    : "grids" == localStorage.getItem("display")
                    ? jQuery("#grid-views").trigger("click")
                    : "list" == localStorage.getItem("display")
                    ? jQuery("#list-view").trigger("click")
                    : "short-list" == localStorage.getItem("display")
                    ? jQuery("#short-list-view").trigger("click")
                    : jQuery("#grid-view").trigger("click"),
                o.initInfiniteScrolling(),
                $(".spr-badges").length > 0)
            )
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
        },
        sidebarCreateUrl: function (t) {
            var i = e.param(Shopify.queryParams).replace(/%2B/g, "+");
            return t ? ((location.href = t + "?" + i), "" != i ? t + "?" + i : t) : location.pathname + "?" + i;
        },
        sidebarAjaxClick: function (e) {
            delete Shopify.queryParams.page;
            var t = o.sidebarCreateUrl(e);
            (o.isSidebarAjaxClick = !0), window.history.pushState({ param: Shopify.queryParams }, t, t), o.sidebarGetContent(t);
        },
        sidebarGetContent: function (t) {
            $.ajax({
                type: "get",
                url: t,
                beforeSend: function () {
                    o.showLoading();
                },
                success: function (e) {
                    o.sidebarMapData(e),
                        o.sidebarMapTagEvents(),
                        o.sidebarMapClear(),
                        o.sidebarMapClearAll(),
                        o.hideLoading(),
                        o.initQuickView(),
                        o.initAddToCart(),
                        o.initAddToCarts(),
                        o.initWishlist(),
                        o.sidebarMapPaging(),
                        countDownIni(".flip-countdown");
                    var t = $(".shop_masonry");
                    t.length > 0 &&
                        (t.imagesLoaded(function () {
                            t.masonry({ itemSelector: ".ms-item", columnWidth: ".ms-item", percentPosition: !0 });
                        }),
                        o.initInfiniteScrolling());
                },
                error: function (t, i) {
                    o.hideLoading(), e(".loading-modal").hide(), e(".ajax-error-message").text($.parseJSON(t.responseText).description), o.showModal(".ajax-error-modal");
                },
            });
        },
        sidebarParams: function () {
            if (((Shopify.queryParams = {}), location.search.length))
                for (var e, t = 0, i = location.search.substr(1).split("&"); t < i.length; t++) (e = i[t].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1]));
        },
        FacetFiltersForm: function () {
            class e extends HTMLElement {
                constructor() {
                    super(),
                        (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
                        (this.debouncedOnSubmit = debounce((e) => {
                            this.onSubmitHandler(e);
                        }, 500)),
                        this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
                    const e = this.querySelector("#FacetsWrapperDesktop");
                    e && e.addEventListener("keyup", onKeyUpEscape);
                }
                static setListeners() {
                    window.addEventListener("popstate", (t) => {
                        const i = t.state ? t.state.searchParams : e.searchParamsInitial;
                        i !== e.searchParamsPrev && e.renderPage(i, null, !1);
                    });
                }
                static toggleActiveFacets(e = !0) {
                    document.querySelectorAll(".js-facet-remove").forEach((t) => {
                        t.classList.toggle("disabled", e);
                    });
                }
                static renderPage(t, i, r = !0) {
                    e.searchParamsPrev = t;
                    const o = e.getSections(),
                        a = document.getElementById("ProductCount"),
                        s = document.getElementById("ProductCountDesktop");
                    document.getElementById("ProductGridContainer").querySelector(".collection_template").classList.add("loading"),
                        a && a.classList.add("loading"),
                        s && s.classList.add("loading"),
                        o.forEach((r) => {
                            const o = `${window.location.pathname}?section_id=${r.section}&${t}`,
                                a = (e) => e.url === o;
                            e.filterData.some(a) ? e.renderSectionFromCache(a, i) : e.renderSectionFromFetch(o, i);
                        }),
                        r && e.updateURLHash(t);
                }
                static renderSectionFromFetch(t, i) {
                    fetch(t)
                        .then((e) => e.text())
                        .then((r) => {
                            const a = r;
                            if (
                                ((e.filterData = [...e.filterData, { html: a, url: t }]),
                                e.renderFilters(a, i),
                                e.renderProductGridContainer(a),
                                o.sidebarMapView(),
                                o.initAddToCart(),
                                o.initQuickView(),
                                o.initWishlist(),
                                jQuery(".filter-left").on("click", function (e) {
                                    e.preventDefault(), jQuery(this).toggleClass("active"), jQuery(".off-canvas.position-left").addClass("is-open"), jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
                                }),
                                jQuery(".filter-right").on("click", function (e) {
                                    e.preventDefault(), jQuery(this).toggleClass("active"), jQuery(".off-canvas.position-right").addClass("is-open"), jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
                                }),
                                jQuery(".off-canvas .sidebar_close").on("click", function (e) {
                                    e.preventDefault(),
                                        jQuery(".off-canvas.position-left").removeClass("is-open"),
                                        jQuery(".off-canvas.position-right").removeClass("is-open"),
                                        jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
                                }),
                                jQuery(".is-overlay-fixed").on("click", function (e) {
                                    e.preventDefault(),
                                        jQuery(".filter-left").trigger("click"),
                                        jQuery(".filter-right").trigger("click"),
                                        jQuery(".off-canvas.position-left").removeClass("is-open"),
                                        jQuery(".off-canvas.position-right").removeClass("is-open"),
                                        jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
                                }),
                                jQuery(".filter-toggle").on("click", function (e) {
                                    e.preventDefault(), jQuery(this).toggleClass("active"), jQuery(".filter-toggle-wrap").slideToggle("is-visible");
                                }),
                                $("body:not(.rtl) .category_feature1").owlCarousel({
                                    items: 4,
                                    nav: !1,
                                    dots: !1,
                                    autoplay: !1,
                                    loop: !0,
                                    rewind: !0,
                                    rtl: !1,
                                    autoplayHoverPause: !1,
                                    responsive: { 100: { items: 1 }, 481: { items: 2 }, 768: { items: 3 }, 992: { items: 3 }, 1200: { items: 4 } },
                                }),
                                $("body.rtl .category_feature1").owlCarousel({
                                    items: 3,
                                    nav: !1,
                                    dots: !1,
                                    autoplay: !0,
                                    loop: !0,
                                    rewind: !0,
                                    rtl: !1,
                                    autoplayHoverPause: !1,
                                    responsive: { 100: { items: 1 }, 481: { items: 2 }, 768: { items: 3 }, 992: { items: 3 }, 1200: { items: 3 } },
                                }),
                                $(".spr-badges").length > 0)
                            )
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                        });
                }
                static renderSectionFromCache(t, i) {
                    const r = e.filterData.find(t).html;
                    if (
                        (e.renderFilters(r, i),
                        e.renderProductGridContainer(r),
                        o.sidebarMapView(),
                        o.initAddToCart(),
                        o.initQuickView(),
                        o.initWishlist(),
                        jQuery(".filter-left").on("click", function (e) {
                            e.preventDefault(), jQuery(this).toggleClass("active"), jQuery(".off-canvas.position-left").addClass("is-open"), jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
                        }),
                        jQuery(".filter-right").on("click", function (e) {
                            e.preventDefault(), jQuery(this).toggleClass("active"), jQuery(".off-canvas.position-right").addClass("is-open"), jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
                        }),
                        jQuery(".off-canvas .sidebar_close").on("click", function (e) {
                            e.preventDefault(),
                                jQuery(".off-canvas.position-left").removeClass("is-open"),
                                jQuery(".off-canvas.position-right").removeClass("is-open"),
                                jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
                        }),
                        jQuery(".is-overlay-fixed").on("click", function (e) {
                            e.preventDefault(),
                                jQuery(".filter-left").trigger("click"),
                                jQuery(".filter-right").trigger("click"),
                                jQuery(".off-canvas.position-left").removeClass("is-open"),
                                jQuery(".off-canvas.position-right").removeClass("is-open"),
                                jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
                        }),
                        jQuery(".filter-toggle").on("click", function (e) {
                            e.preventDefault(), jQuery(this).toggleClass("active"), jQuery(".filter-toggle-wrap").slideToggle("is-visible");
                        }),
                        $("body:not(.rtl) .category_feature1").owlCarousel({
                            items: 4,
                            nav: !1,
                            dots: !1,
                            autoplay: !1,
                            loop: !0,
                            rewind: !0,
                            rtl: !1,
                            autoplayHoverPause: !1,
                            responsive: { 100: { items: 1 }, 481: { items: 2 }, 768: { items: 3 }, 992: { items: 3 }, 1200: { items: 4 } },
                        }),
                        $("body.rtl .category_feature1").owlCarousel({
                            items: 4,
                            nav: !1,
                            dots: !1,
                            autoplay: !1,
                            loop: !0,
                            rewind: !0,
                            rtl: !1,
                            autoplayHoverPause: !1,
                            responsive: { 100: { items: 1 }, 481: { items: 2 }, 768: { items: 3 }, 992: { items: 3 }, 1200: { items: 4 } },
                        }),
                        $(".spr-badges").length > 0)
                    )
                        return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                }
                static renderProductGridContainer(e) {
                    document.getElementById("ProductGridContainer").innerHTML = new DOMParser().parseFromString(e, "text/html").getElementById("ProductGridContainer").innerHTML;
                }
                static renderFilters(t, i) {
                    const r = new DOMParser().parseFromString(t, "text/html"),
                        o = r.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"),
                        a = (e) => {
                            const t = i ? i.target.closest(".js-filter") : void 0;
                            return !!t && e.dataset.index === t.dataset.index;
                        },
                        s = Array.from(o).filter((e) => !a(e)),
                        n = Array.from(o).find(a);
                    s.forEach((e) => {
                        document.querySelector(`.js-filter[data-index="${e.dataset.index}"]`).innerHTML = e.innerHTML;
                    }),
                        e.renderActiveFacets(r),
                        e.renderAdditionalElements(r),
                        n && e.renderCounts(n, i.target.closest(".js-filter"));
                }
                static renderActiveFacets(t) {
                    [".active-facets-mobile", ".active-facets-desktop"].forEach((e) => {
                        const i = t.querySelector(e);
                        i && (document.querySelector(e).innerHTML = i.innerHTML);
                    }),
                        e.toggleActiveFacets(!1);
                }
                static renderAdditionalElements(e) {
                    [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((t) => {
                        e.querySelector(t) && (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML);
                    }),
                        document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents();
                }
                static renderCounts(e, t) {
                    const i = t.querySelector(".facets__selected");
                    e.querySelector(".facets__selected") && i && (t.querySelector(".facets__selected").outerHTML = e.querySelector(".facets__selected").outerHTML);
                }
                static updateURLHash(e) {
                    history.pushState({ searchParams: e }, "", `${window.location.pathname}${e && "?".concat(e)}`);
                }
                static getSections() {
                    return [{ section: document.getElementById("product-grid").dataset.id }];
                }
                onSubmitHandler(t) {
                    t.preventDefault();
                    const i = new FormData(t.target.closest("form")),
                        r = new URLSearchParams(i).toString();
                    e.renderPage(r, t);
                }
                onActiveFilterClick(t) {
                    t.preventDefault(), e.toggleActiveFacets(), e.renderPage(new URL(t.currentTarget.href).searchParams.toString()), o.sidebarMapView(), o.initAddToCart();
                }
            }
            (e.filterData = []), (e.searchParamsInitial = window.location.search.slice(1)), (e.searchParamsPrev = window.location.search.slice(1)), customElements.define("facet-filters-form", e), e.setListeners();
            class t extends HTMLElement {
                constructor() {
                    super(), this.querySelectorAll("input").forEach((e) => e.addEventListener("change", this.onRangeChange.bind(this))), this.setMinAndMaxValues();
                }
                onRangeChange(e) {
                    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
                }
                setMinAndMaxValues() {
                    const e = this.querySelectorAll("input"),
                        t = e[0],
                        i = e[1];
                    i.value && t.setAttribute("max", i.value), t.value && i.setAttribute("min", t.value), "" === t.value && i.setAttribute("min", 0), "" === i.value && t.setAttribute("max", i.getAttribute("max"));
                }
                adjustToValidValues(e) {
                    const t = Number(e.value),
                        i = Number(e.getAttribute("min")),
                        r = Number(e.getAttribute("max"));
                    t < i && (e.value = i), t > r && (e.value = r);
                }
            }
            customElements.define("price-range", t);
            class i extends HTMLElement {
                constructor() {
                    super(),
                        this.querySelector("a").addEventListener("click", (e) => {
                            e.preventDefault();
                            (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(e);
                        });
                }
            }
            customElements.define("facet-remove", i);
        },
        initInfiniteScrolling: function () {
            e(".infinite-scrolling").length > 0 &&
                e(".infinite-scrolling a.next").click(function (t) {
                    t.preventDefault(), e(this).hasClass("disabled") || o.doInfiniteScrolling();
                });
        },
        doInfiniteScrolling: function () {
            var e = $(".col-main .products-grid-view");
            if (e) {
                var t = $(".infinite-scrolling a.next").first();
                $.ajax({
                    type: "GET",
                    url: t.attr("href"),
                    beforeSend: function () {
                        o.showLoading(), $(".loading-modal").show(), (al_is_loading = !0);
                    },
                    success: function (i) {
                        o.hideLoading();
                        var r = $(".products-grid-view"),
                            a = $(i).find(".col-main .products-grid-view");
                        if (((al_is_loading = !1), $(i).find(".infinite-scrolling").length > 0 ? t.attr("href", $(i).find(".infinite-scrolling a.next").attr("href")) : (t.removeClass("next"), t.hide(), t.next().show()), a.length)) {
                            var s = a.children().length,
                                n = $(".loadcount").html(),
                                c = parseInt(s) + parseInt(n);
                            if (
                                ($(".loadcount").html(c),
                                $(".pag-product").html(c),
                                jQuery(".products-grid-view > div.product-short-list").each(function () {
                                    var e = jQuery(this).find(".product-wrapper .product-description .short-title");
                                    jQuery(e).children().unwrap();
                                }),
                                $(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a").click(function () {
                                    $(this).addClass("loading"),
                                        setTimeout(function () {
                                            $(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a").removeClass("loading");
                                        }, 2e3);
                                }),
                                jQuery(".collections_masonry.shop_masonry").each(function () {
                                    r.append(a.children()).each(function () {
                                        r.masonry("reloadItems"), $(".products-grid-view > div.product-collection-item ").addClass("product-grid");
                                    });
                                }),
                                e.append(a.children()),
                                o.initQuickView(),
                                o.initAddToCart(),
                                o.initAddToCarts(),
                                o.initWishlist(),
                                $(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a,.pro_btn.add-to-compare .add-in-compare-js").click(function () {
                                    $(this).addClass("loading"),
                                        setTimeout(function () {
                                            $(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a, .pro_btn.add-to-compare .add-in-compare-js").removeClass("loading");
                                        }, 2e3);
                                }),
                                countDownIni(".flip-countdown"),
                                "grid" == localStorage.getItem("display")
                                    ? jQuery("#grid-view").trigger("click")
                                    : "grids" == localStorage.getItem("display")
                                    ? jQuery("#grid-views").trigger("click")
                                    : "list" == localStorage.getItem("display")
                                    ? jQuery("#list-view").trigger("click")
                                    : "short-list" == localStorage.getItem("display")
                                    ? jQuery("#short-list-view").trigger("click")
                                    : jQuery("#grid-view").trigger("click"),
                                jQuery(".collections_masonry.shop_masonry").each(function () {
                                    r.imagesLoaded(function () {
                                        r.masonry();
                                    });
                                }),
                                window.show_multiple_currencies &&
                                    window.shop_currency != jQuery(".currencies li.active .currencies-a").val() &&
                                    Currency.convertAll(window.shop_currency, jQuery(".currencies li.active .currencies-a").val(), "span.money", "money_format"),
                                o.initColorSwatchGrid(),
                                $(".spr-badges").length > 0)
                            )
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                        }
                    },
                    error: function (e, t) {
                        o.hideLoading(), $(".loading-modal").hide(), $(".ajax-error-message").text($.parseJSON(e.responseText).description), o.showModal(".ajax-error-modal");
                    },
                    dataType: "html",
                });
            }
        },
    };
    $(".product-form__input.variant-options").each(function () {
        var e = $(this).attr("data-var-opt"),
            t = ".variant-options[data-var-opt=" + e + "] .option-variant-main .option-variant input",
            i = $(t).attr("value");
        $(".variant-options[data-var-opt=" + e + "] .selected-variant").attr("data-var-select");
        $(this).find(".selected-variant").text(i),
            $(t).click(function () {
                var e = $(this).attr("value");
                $(t).parents(".product-form__input.variant-options").find(".selected-variant").text(e);
            });
    });
})(jQuery),
    $(function () {
        $("img.lazy").lazyload({ effect: "fadeIn" });
    }),
    $("img.lazy").show().lazyload({ effect: "fadeIn" });
